import { useState, useEffect } from 'react';
import { trainingFlowsApi } from '../../agents/services/trainingFlowsApi';
import { AgentTrainingFlow } from '../../agents/types/flowTypes';
import { supabase } from '../../../integrations/supabase/client';

export interface WorkflowWithAgent extends AgentTrainingFlow {
  assigned_agent_name?: string | null;
}

export const useWorkflows = () => {
  const [workflows, setWorkflows] = useState<WorkflowWithAgent[]>([]);
  const [loading, setLoading] = useState(true);

  const loadWorkflows = async () => {
    try {
      setLoading(true);

      const flows = await trainingFlowsApi.listWorkflows();

      // Fetch agents that reference these workflows via active_workflow_id
      if (flows.length > 0) {
        const flowIds = flows.map(f => f.id);
        const { data: agents } = await supabase
          .from('agents')
          .select('nombre, active_workflow_id')
          .in('active_workflow_id', flowIds);

        const agentMap: Record<string, string> = {};
        (agents || []).forEach(a => {
          if (a.active_workflow_id) {
            agentMap[a.active_workflow_id] = a.nombre;
          }
        });

        setWorkflows(flows.map(f => ({
          ...f,
          assigned_agent_name: agentMap[f.id] || null,
        })));
      } else {
        setWorkflows([]);
      }
    } catch (error) {
      console.error('[useWorkflows] ❌ Error loading workflows:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadWorkflows();
  }, []);

  return {
    workflows,
    loading,
    reload: loadWorkflows,
  };
};
